import { render } from "./ClientSidebar.vue?vue&type=template&id=7c1c2efe&scoped=true"
import script from "./ClientSidebar.vue?vue&type=script&lang=js"
export * from "./ClientSidebar.vue?vue&type=script&lang=js"

import "./ClientSidebar.vue?vue&type=style&index=0&id=7c1c2efe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c1c2efe"]])

export default __exports__